<template>
  <div class="saturn-force">
    <span class="saturn-force-text">One more thing…</span>
  </div>
</template>
<script>
export default {
  name: 'AdsorptionForce2',
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    const masterTimeline = this.$gsap.timeline({
      scrollTrigger: {
        trigger: '.saturn-force-text',
        start: 'top 75%',
        end: 'bottom 60%',
        toggleActions: 'play none none none',
        markers: false,
        // scrub: 3,
        once: true
      }
    })

    masterTimeline.from('.saturn-force-text', {
      opacity: 0,
      duration: 1,
      y: 100,
      ease: 'power2.inOut'
    })
  }
}

</script>
<style scoped>
.saturn-force {
  background-image: linear-gradient(#d7d8d8, #273953);
  height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.saturn-force-text {
  color: #ffffff;
  font-size: var(--font-size-lg2);
}
</style>
